import { EntityType } from './entity-type.enum';

export enum ExecutionStatus {
    success,
    failure,
    warning,
}

export interface GenericError {
    message: string;
    caption: string;
    errorNumber: number;
}

export interface Warning {
    warningNumber: number;
    message: string;
    manualOverride: boolean;
    AvalilableOptions: Array<[string, string]>;
    OverrideOption: [string, string];
}

export interface ExecutionResult {
    result: {
        status: ExecutionStatus;
        returnXml: string;
        errors: GenericError[];
        warnings: Warning[];
    };
    intermediateSessionId?: string;
}

export interface ExecuteQueryResult<T> extends ExecutionResult {
    records: T[],
}

export class  AvionBusinessEntity {
    AbeName?: string;
    EntityId?: string;
    EntityTypeId?: string;
    DisplayId?: number;
    PublicHospital?: boolean;
    CloneSourceId?: string;
    CreationDate?: Date;
    Creator?: string;
    CreatorDesc?: string;
    ModificationDate?: Date;
    Modifier?: string;
    ModifierDesc?: string;
    Description?: string;
    LegacySystemDescription?: any;
    LegacySystemIdentifier?: any;
    OwnerEntity?: string;
    OwnerEntityId?: string;
    OwnerEntityTypeId?: string;
    OwnerDescription?: any;
}

export class SysUser extends AvionBusinessEntity {
    __type?: string;
    UserName?: string;
    Password?: string;
    FirstName?: string;
    LastName?: string;
    WindowsAccount?: string;
    EmailAddress?: string;
    SessionId?: string = '';
    SiteId?: string;
    WebUserId?: string;
    IsSystem?: boolean;

    constructor() {
        super();
        this.EntityId = "00000000-0000-0000-0000-000000000000";
        this.EntityTypeId = "6D6C84AF-A441-40C3-9C95-353083BE6A3F";
    }
}

export const individualCurrentStatus = 'Provisional';

export class Individual extends AvionBusinessEntity {
    ReciprocalId?: number;
    SubType?: string;
    Extra2: string = '';
    MiddleName: string = '';
    Aboriginal?: boolean;
    PostGradQualsOther: string = '';
    StatementOfAccountEmailCC: string = '';
    RACSID: string = '';
    DefaultPwd: string = '';
    OrganisationName: string = '';
    OrganisationType: string = '';
    MBBSGraduationDate?: Date;
    Title?: string;
    Webuserid?: string;
    TitleName: string = '';
    EmailAddress: string = '';
    Citizenship?: string;
    associations: string = '';
    GraduateInstitute: string = '';
    Gender?: string;
    GenderName?: string;
    Spouse: string = '';
    TorresStraitIslander?: boolean;
    TrainingCompletionYear?: number;
    Qualifications: string = '';
    OTPMode: string = '';
    Status?: string;
    Metro?: boolean;
    JobTitle: string = '';
    SocietyMemberships: string = '';
    PracticingStatus?: string;
    awards: string = '';
    DateDeceased?: Date;
    SourceCode: string = '';
    Branch?: string;
    Extra1: string = '';
    Languages: string = '';
    Hospitals: string = '';
    StatementOfAccountEmail: string = '';
    WebUserId: string = '';
    PostNoms: string = '';
    TFN!: string;
    ABN!: string;
    OperatingStatus?: string;
    FirstName: string = '';
    RelatedEntities?: string;
    Extra4: string = '';
    BirthDate?: Date;
    OTPTarget: string = '';
    LatestMembershipInvoice?: string;
    associateyear?: number;
    LastName: string = '';
    PostGradQuals: string = '';
    SubspecialityAreas: string = '';
    Type?: string;
    FellowYear?: number;
    CurrentStatus!: string;
    Extra3: string = '';
    overseas?: boolean;
    StateOfTraining: string = '';
    RegistrationNumber: string = '';
    PreferredName: string = '';
    __type: string;

    constructor() {
        super();
        this.EntityTypeId = EntityType.individual;
        this.EntityId = '00000000-0000-0000-0000-000000000000';
        this.__type = 'individual:#Avion.Genesis.Avalon.Core';
        this.CurrentStatus = individualCurrentStatus;
    }
}

export interface ListResult<T> extends ExecutionResult {
    abeList: T[];
}

